import { Constants } from "../../../../../../constants/constants";
import { SharedFields } from "../../configs";
import { ScreenSectionConfigType, ScreenType } from "../../wf-difference.types";

const analysisField: ScreenSectionConfigType = {
  field: "analysisAE",
  label: "data_entry.analysis",
  view: "normal",
  visibleIf: (data: { itemType: number }) => data.itemType === Constants.CONSTANT_DATA_ENTRY_INFO,
};

const recommendationsField: ScreenSectionConfigType = {
  field: "recommendationsAE",
  label: "data_entry.recommendations",
  view: "normal",
  visibleIf: (data: { itemType: number }) => data.itemType === Constants.CONSTANT_DATA_ENTRY_INFO,
};

const areasOfImprovementsField: ScreenSectionConfigType = {
  field: "areasOfImprovementsAE",
  label: "data_entry.areas_of_improvement",
  view: "normal",
  visibleIf: (data: { itemType: number }) => data.itemType === Constants.CONSTANT_DATA_ENTRY_INFO,
};

const pmoNotesField: ScreenSectionConfigType = {
  field: "pmoNotesAE",
  label: "kpi.pmo_notes",
  view: "normal",
};

const periodField: ScreenSectionConfigType = {
  field: "period",
  label: "data_entry.period",
  view: "normal",
  visibleIf: (data: { itemType: number }) => data.itemType === Constants.CONSTANT_DATA_ENTRY_INFO,
};

const yearField: ScreenSectionConfigType = {
  field: "year",
  label: "common.form.label.year",
  view: "normal",
  visibleIf: (data: { itemType: number }) => data.itemType === Constants.CONSTANT_BENCHMARK_DATA_ENTRY_INFO,
};

export const dataEntryInfoScreenConfig = {
  type: "data-entry-info" as ScreenType,
  sections: [
    analysisField,
    recommendationsField,
    areasOfImprovementsField,
    pmoNotesField,
    periodField,
    yearField,
    SharedFields.attachmentsField,
  ],
};
